import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Card, Table, Tag } from 'antd'
import { req_single_cms_learnmap_talent_ability_course } from '../../api'

class CoursemapStudentSuggestCourseModal extends Component {
    // 基礎通用參數 //////////////////////////////////////////////   
    static propTypes = {
        course: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        item: {},
        items: []
    }


    state = {
        loading: false,
        item: {},
        items: []
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.init()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_init_items = async (selector) => {
        //console.log(selector)
        const { token } = this.props.user
        this.setState({ loading: true })
        const result = await req_single_cms_learnmap_talent_ability_course(selector, token)
        console.log(result)
        if (result) {
            if (result.total > 0) {
                const data = result.data
                console.log('data',data)
                const items = data.filter(function (row) {
                    return row.courseGrade = -1
                })
                // console.log('items',items)
                this.setState({ items })
            }
            this.setState({ loading: false })
        } else {
            this.setState({ loading: false })
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    init = () => {
        // console.log('course',this.props.course)
        const { userCode } = this.props.user
        const { abilityName, nidLearnMapMeta, nidTalent, gidTalentAbility } = this.props.course
        const selector = {
            abilityName: abilityName,
            nidLearnMapMeta: nidLearnMapMeta,
            nidTalent: nidTalent,
            gidTalentAbility: gidTalentAbility,
            studentId: userCode
        }
        this.api_init_items(selector)
    }

    /////////////////////////////////////////////////////////////     
    render() {
        //console.log(this.props.activity)
        const { items } = this.state
        const { abilityName } = this.props.course
        const columns = [
            {
                title: '年級',
                dataIndex: 'studentGrade',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '學期',
                dataIndex: 'studentSemester',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '課程',
                dataIndex: 'courseTwName',
                width: 60,
            },
            {
                title: '學分',
                dataIndex: 'courseCredit',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '必(選)修',
                dataIndex: 'courseChooseType',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '建議',
                width: 40,
                render: (item) => {
                    const { mnaTypeCode } = item
                    return (
                        <div className='text-center'>
                           { mnaTypeCode === 'M' ? (<Tag color='red'>本課程對本能力貢獻大</Tag>) : (<Tag color='orange'>本課程對本能力貢獻小</Tag>)}
                        </div>
                    )
                },
            },
        ]
        const title = (<><i className="fas fa-code-branch"></i> {abilityName} 能力指標</>)

        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 560 }}
                    rowKey='courseCode'
                    dataSource={items}
                    pagination={false}
                    columns={columns}
                />
            </Card>
        )

    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentSuggestCourseModal)